<template>
    <div class="transBoutique fix">
        <div class="title">
            <strong class="yahei fl">{{title}}</strong>
        </div>
        <div class="listGood" v-if="list">
            <ul class="fix">
                <li v-for="(item,index) in list" :key="index">
                    <div class="imgGood pic">
                        <a :href="`https://auction.artron.net/paimai-${item.ArtCode}`" target="_blank">
                            <img :src="`${item.Folder}${item.FileName}`" />
                        </a>

                    </div>
                    <a class="name auctionFont fontLine color333 oneLineText" :href="`https://auction.artron.net/paimai-${item.ArtCode}`" target="_blank">{{ item.WorkName }}</a>
                    <div class="price fontSong12 color999">
                        {{ name }}
                        <template v-if="name === '估价'">
                            <span v-if="item.EvaluationType === 0" class="red verdanF12">{{item.CurrencyType}} {{ item.OriginalEvaluation == 0 ? '--' : item.OriginalEvaluation.toLocaleString() }} - {{ item.LastEvaluation == 0 ? '--' : item.LastEvaluation.toLocaleString()  }}</span>
                            <span v-if="item.EvaluationType === 1" class="red verdanF12">无底价</span>
                            <span v-if="item.EvaluationType === 2" class="red verdanF12">资询价</span>
                            <span v-if="item.EvaluationType === 3" class="red verdanF12">估价待定</span>
                        </template>
                        <template v-else>
                            <span class="red verdanF12">{{ item.CurrencyType }} {{ item.CurrencyPrice.toLocaleString() }}</span>
                        </template>
                    </div>
                    
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "transBoutique",
    props: {
        list: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        t:{
            type:Number
        }
    },
    data(){
        return{
            goodList:[{},{},{},{},{},{}],
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.transBoutique{
    border-top: 1px solid #dcdcdc;
    position: relative;
    .title{
        height: 38px;
        strong{
            display: block;
            border-top: 3px solid #000;
            width: 105px;
            height: 36px;
            line-height: 36px;
            position: absolute;
            top: -1px;
            left: 0px;
            font-size: 16px;
            padding-left: 10px;
            box-sizing: content-box;
        }
    }
    .listGood{
        float: left;
        li{
            width: 155px;
            height: 254px;
            position: relative;
            margin-right: 20px;
            float: left;
            &:nth-child(4n){
                margin-right: 0;
            }
            .imgGood{
                width: 180px;
                height: 180px;
                text-align: center;
                border: 1px solid #eeeeee;
                overflow: hidden;
                img {
                    object-fit: contain;
                    width: 100%;
                    height: 100%;
                }
            }
            .pic{
                display: table-cell;
                vertical-align: middle;
                table-layout: fixed;
            }
            .name{
                text-align: center;
                display: block;
                padding-top: 3px;
            }
        }
    }

}
</style>